import { Attr, BelongsTo, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type Website from "./Website";

@Model()
class WebsiteDomain extends ApplicationRecord {
  static jsonapiType = "website_domains";

  @Attr({ persist: false }) createdAt: string;

  @Attr() domain: string;

  @Attr() primary: boolean;

  @Attr({ persist: false }) updatedAt: string;

  @BelongsTo() website: Website;
}

export default WebsiteDomain;
